// extracted by mini-css-extract-plugin
module.exports = {"reportTable":"ReportTable_reportTable__1veZZ","tableHeader":"ReportTable_tableHeader__RuNOp","tableBody":"ReportTable_tableBody__1DbZy"};